function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$('.submit').click(function(e){
  e.preventDefault();
  
  var bandera = 0;
  
  $('.field-required input:visible').each(function(){
    var input = $(this).val();

    if(input == '') {
      bandera = 1;
      $(this).next('.error').css('display', 'block');
    } else {
      $(this).next('.error').css('display', 'none');
    }
  });
  
  if (bandera == 1) {
    return false;
  }

  var correo  = $("#correo").val();
  var nombre  = $("#nombre").val();
  
  console.log('email: ' + correo);
  console.log('nombre: ' + nombre);

  var data = '{"fields":[{"name": "email", "value": "'+ correo +'"},{"name": "firstname", "value": "'+ nombre +'"}, {"name": "origen_del_contacto", "value": "Ecommerce Básculas"}]}';
  
  jQuery.ajax({
    url: 'https://forms.hsforms.com/emailcheck/v1/json-ext?portalId=9454951&includeFreemailSuggestions=true',
    type: "POST",
    data: correo,
    dataType: 'json',
    success: function (response) {
      console.log(response);
      if(!response.success){
        $('.field-correo .error').text('Correo inválido');
        $('.field-correo .error').css('display', 'block');
      }
      else{
        $.ajax({
          url: 'https://api.hsforms.com/submissions/v3/integration/submit/9454951/440295c7-6a17-4f30-a4eb-e95cbb2ac7ff',
          crossDomain: true,
          async: true,
          headers: {
            "content-type": "application/json",
            "cache-control": "no-cache",
          },
          data: data,
          type: 'POST',
          dataType: 'json',
          success: function(response) {
            $('.f-sus').html('<p id="message">Gracias por suscribirte, pronto recibirás novedades y ofertas exclusivas en básculas electrónicas</p>');
          },
          error: function(jqXHR, exception) {

          }
        });
      }
    }
  });
  
});  